import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HrIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.42864 8.35679C8.20384 8.35679 9.64293 6.91771 9.64293 5.14251C9.64293 3.36731 8.20384 1.92822 6.42864 1.92822C4.65344 1.92822 3.21436 3.36731 3.21436 5.14251C3.21436 6.91771 4.65344 8.35679 6.42864 8.35679Z",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M0.643066 17.3569H12.2145V16.6599C12.2043 15.6799 11.9458 14.7185 11.4633 13.8655C10.9808 13.0124 10.2899 12.2957 9.45526 11.782C8.6206 11.2684 7.66938 10.9747 6.69045 10.9283C6.60317 10.9242 6.51593 10.9221 6.42878 10.9219C6.34163 10.9221 6.25439 10.9242 6.16711 10.9283C5.18818 10.9747 4.23696 11.2684 3.4023 11.782C2.56765 12.2957 1.8768 13.0124 1.39427 13.8655C0.911751 14.7185 0.653302 15.6799 0.643066 16.6599V17.3569Z",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.5718 8.35679C13.347 8.35679 14.7861 6.91771 14.7861 5.14251C14.7861 3.36731 13.347 1.92822 11.5718 1.92822",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.786 17.3568H17.3574V16.6596C17.3471 15.6797 17.0887 14.7182 16.6062 13.8653C16.1237 13.0122 15.4328 12.2954 14.5982 11.7818C14.0587 11.4498 13.4703 11.2097 12.8574 11.0688",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
